export default __webpack_public_path__ + "static/media/share-grey.c14d058c.svg";